<template>
    <v-col cols="12">
        <v-row class="ml-2">
            <v-col cols="10" class="py-0 py-sm-2">
                    <span class="text-body-1 grey--text text--darken-3 font-weight-bold">{{ $t('order') }}&nbsp;Agrolink</span>
            </v-col>
            <v-col cols="2" class="py-0 py-sm-2">
                <div class="d-flex d-sm-none">
                    <v-btn
                        small
                        icon
                        :to="{name: 'Basket'}"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <seller-item
            v-for="(order, idx) in orders"
            :key="idx"
            :order="order"
            :date="date"
            :paymentWay="paymentWay"
        ></seller-item>
        <v-row class="d-flex flex-wrap px-2 px-sm-4">
            <v-col cols="12" class="pb-0 pt-5">
                <span class="text-body-1 grey--text text--darken-3 font-weight-bold">{{ $t('addressDelivery') }}</span>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
                <v-autocomplete
                    v-model="formData.region"
                    :items="regions"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    item-color="orange lighten-2"
                    :label="$t('region')"
                    return-object
                    color="orange lighten-2"
                    @change="regionChange"
                    :rules="rules.text"
                    required
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
                <v-autocomplete
                    v-model="formData.geo"
                    :items="settlements"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    item-color="orange lighten-2"
                    :label="$t('settlement')"
                    return-object
                    color="orange lighten-2"
                    :disabled="!settlements.length"
                    :loading="settlementsLoad"
                    :rules="rules.text"
                    required
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
                <v-text-field
                    v-model="formData.address"
                    :label="$t('address')"
                    color="orange lighten-2"
                    :rules="rules.text"
                    required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex flex-wrap my-2 px-2 px-sm-4">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        info_outlined
                    </v-icon>
                </template>
                <span>{{ $t('setRecommendOrderDate') }}</span>
            </v-tooltip>
            <div>
                <span class="pr-2">{{ $t('deliveryDate') }}:</span>
                <delivery-date :dialog-data="failSeller" @date-change="orderDateChange"></delivery-date>
            </div>
        </div>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex flex-wrap my-2 px-2 px-sm-4">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        info_outlined
                    </v-icon>
                </template>
                <span>{{ $t('paymentWaySet') }}</span>
            </v-tooltip>
            <span class="pr-2">{{ $t('paymentMethod') }}:</span>
            <div>
                <payment-method
                    :dialog-data="failSeller"
                    :payment-ways="paymentWays"
                    @payment-change="orderPaymentChange"
                ></payment-method>
            </div>
        </div>
        <v-divider class="my-1"></v-divider>
        <v-row class="d-flex flex-wrap px-2 px-sm-4">
            <v-col cols="12" class="mt-2">
                <span class="text-body-1 grey--text text--darken-3 font-weight-bold">{{ $t('messagesToSeller') }}</span>
            </v-col>
            <v-col cols="12" class="">
                <v-textarea
                    v-model="message"
                    :hide-details="true"
                    color="orange lighten-2"
                    outlined
                    :label="$t('messageText')"
                    :placeholder="`${$t('hello')} ...`"
                ></v-textarea>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import SellerItem from "./SellerItem";
import DeliveryDate from "../../basket/v-2/DeliveryDate";
import PaymentMethod from "../../basket/v-2/PaymentMethod";

import OrderCalculator from "../../../../app-front/mixins/OrderCalculator";
import OrderDataProvider from "../../../../app-front/mixins/OrderDataProvider";

import GeoService from "../../../../app-front/services/api/GeoService";
import OrderService from "../../../../app-front/services/api/OrderService";

export default {
    name: "AgrolinkOrderList",
    components: { SellerItem, DeliveryDate, PaymentMethod },
    mixins: [OrderDataProvider, OrderCalculator],
    props: ['orders'],
    data() {
        return {
            formData: {},
            message: '',
            rules: {
                text: [
                    v => !!v || this.$t('requiredField'),
                ],
            },
            settlements: [],
            settlementsLoad: false,
            date: null,
            paymentWay: null,
            paymentWays: [],
            creditPolicy: null,
            failSeller: {
                firstName: "Валерій",
                lastName: "Петренко",
                companyName: "Agrolink"
            },
        }
    },
    computed: {
        regions() {
            return this.$store.state.geo.regions;
        },
    },
    methods: {
        regionChange() {
            this.settlementsLoad = true;
            this.settlements = [];
            this.formData.geo = null;
            GeoService.setLocale(this.$store.state.language.appLanguage);
            GeoService.getChildrenSettlements(this.formData.region.id)
                .then(res => {
                    this.settlements = res.data;
                    this.settlementsLoad = false;
                })
                .catch(err => console.log(err))
        },
        orderDateChange(dateValue) {
            this.date = dateValue;
            this.orders.forEach(order => {
                this.setOrderDate({sellerID: order.seller.id, date: this.date});
                this.updateOrderDate({sellerID: order.seller.id, value: this.date});
            });
        },
        orderPaymentChange(data) {
            this.paymentWay = data.value;
            this.creditPolicy = data.creditPolicy;
            this.orders.forEach(order => {
                this.setOrderPayment({
                    sellerID: order.seller.id,
                    creditPolicy: this.creditPolicy,
                    paymentWay: this.paymentWay
                });
                this.updateOrderCreditPolicy({sellerID: order.seller.id, value: this.creditPolicy});
                this.updateOrderPaymentWay({sellerID: order.seller.id, value: this.paymentWay});
            });
        },
        setFormDataToOrder(){
            const delivery = {
                region: this.formData.region,
                geo: this.formData.geo,
                address: this.formData.address,
            };
            this.orders.forEach(item => {
                this.setOrderProductsDelivery({
                    sellerID: item.seller.id,
                    delivery: delivery,
                    message: this.message
                });
            })
        },
        getPaymentWays() {
            OrderService.getActivePaymentWays({ self: true })
                .then(res => {
                    this.paymentWays = res.data;
                })
                .catch(console.log)
        },
    },
    mounted() {
        this.getPaymentWays();
    },
    watch: {
        formData: {
            handler() {
                this.setFormDataToOrder()
            },
            deep: true
        },
        message() {
            this.setFormDataToOrder()
        }
    }


}
</script>

<style scoped>

</style>
